import React from 'react'

import _ from 'lodash'

import Icon from 'shared/components/Icon'
import { Explanation } from 'shared/components/vega/ExpressionEngine'

function getOutcomeIcon (outcome) {
  switch(outcome?.scoreLabelColor) {
    case 'fail':
      return Icon.CrossRedSmall
    case 'warn':
      return Icon.OrangeExclamation
    case 'pass':
    default:
      return Icon.CheckGreenSmall
  }
}

const Outcome = ({ outcome, entry }) => {
  const OutcomeIcon = getOutcomeIcon(outcome)

  return (
    <div className='vega flex no-wrap'>
      <OutcomeIcon className='vega icon large' />

      <div className='vega flex column'>
        <Explanation explanation={entry?.explanation} titleOnly />

        {/* Only show "possible fixes" if recommendations exist and contain non-empty strings */}
        {!_.isEmpty(_.compact(outcome?.recommendations)) ? (
          <div className='vega flex gap small column'>
            <span className='vega title small'>possible fixes:</span>
            {/* Filter out empty recommendations before mapping */}
            <ul className='vega'>
              {_.map(_.compact(outcome?.recommendations), (r, index) => (
                <li className='vega info' key={index}>{r}</li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
    </div>
  )
}

const Outcomes = ({ lumenRun }) => {
  const entries = _.flatMap(lumenRun?.results, result => result?.evaluation?.history)

  // Conditionally transform outcomes: If the first outcome has 'name', create a new array
  // where 'name' is copied to 'formula'. Otherwise, use the original outcomes array.
  // TODO(stefan): Rename name to formula and remove this logic.
  const processedOutcomes = _.has(lumenRun?.outcomes?.[0], 'name')
    ? _.map(lumenRun.outcomes, o => ({ ...o, formula: o.name }))
    : lumenRun?.outcomes

  return <>
    {/* Use processedOutcomes here */}
    {!_.isEmpty(processedOutcomes) && <div className='vega content'>
      {_.chain(processedOutcomes) // Feed the potentially transformed data into the existing chain
        .map( // Keep the rest of the chain exactly as it was in your original code
          outcome => ({
            outcome,
            entry: _.find(entries, entry => _.includes(entry?.formula, outcome?.formula))
          })
        )
        .uniqBy(({ outcome }) => outcome?.formula)
        .map(({ outcome, entry }) => {
          return <Outcome outcome={outcome} entry={entry} key={outcome?.formula} />
        })
        .value()}
    </div>}
  </>
}

export default Outcomes
